import React, { useState, useEffect } from 'react';
import { authenticatedFetch } from '../utils/auth';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await authenticatedFetch('/admin/stats');
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      } else {
        setError('Failed to fetch admin stats');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p>Loading admin dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        padding: '20px', 
        backgroundColor: '#f8d7da', 
        color: '#721c24', 
        borderRadius: '4px',
        margin: '20px'
      }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <h1>Admin Dashboard</h1>
      
      {stats && (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '20px',
          marginBottom: '40px'
        }}>
          <div style={{ 
            padding: '20px', 
            backgroundColor: '#e3f2fd', 
            borderRadius: '8px',
            border: '1px solid #bbdefb',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#1976d2' }}>Total Users</h3>
            <p style={{ fontSize: '2rem', margin: '0', fontWeight: 'bold' }}>{stats.total_users}</p>
          </div>
          
          <div style={{ 
            padding: '20px', 
            backgroundColor: '#e8f5e8', 
            borderRadius: '8px',
            border: '1px solid #c8e6c9',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#388e3c' }}>Active Today</h3>
            <p style={{ fontSize: '2rem', margin: '0', fontWeight: 'bold' }}>{stats.active_users_today}</p>
          </div>
          
          <div style={{ 
            padding: '20px', 
            backgroundColor: '#fff3e0', 
            borderRadius: '8px',
            border: '1px solid #ffcc80',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#f57c00' }}>Total API Calls</h3>
            <p style={{ fontSize: '2rem', margin: '0', fontWeight: 'bold' }}>{stats.total_api_calls}</p>
          </div>
          
          <div style={{ 
            padding: '20px', 
            backgroundColor: '#f3e5f5', 
            borderRadius: '8px',
            border: '1px solid #e1bee7',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#7b1fa2' }}>Calls Today</h3>
            <p style={{ fontSize: '2rem', margin: '0', fontWeight: 'bold' }}>{stats.api_calls_today}</p>
          </div>
        </div>
      )}

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '20px'
      }}>
        <div style={{ 
          padding: '20px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h3>Quick Actions</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '10px' }}>
              <a href="/admin/users" style={{ 
                color: '#007bff', 
                textDecoration: 'none',
                display: 'block',
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: '#e3f2fd'
              }}>
                👥 Manage Users
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="/admin/usage" style={{ 
                color: '#007bff', 
                textDecoration: 'none',
                display: 'block',
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: '#e3f2fd'
              }}>
                📊 View Usage Logs
              </a>
            </li>
            <li style={{ marginBottom: '10px' }}>
              <a href="/admin/settings" style={{ 
                color: '#007bff', 
                textDecoration: 'none',
                display: 'block',
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: '#e3f2fd'
              }}>
                ⚙️ System Settings
              </a>
            </li>
          </ul>
        </div>

        <div style={{ 
          padding: '20px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h3>System Status</h3>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>●</span> API Service: Online
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>●</span> Database: Connected
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>●</span> Google API: Active
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>●</span> Rate Limiting: Enabled
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 